<template>
  <el-dialog
    width="940px"
    top="30vh"
    :visible.sync="dialogCurrency"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @close="closeDialog"
    custom-class="code-dialog"
  >
    <div sort="title" class="code-title">{{ titleText }}</div>
    <div class="code-body">
      <div class="code-display">
        <div class="code-list" v-for="(item, index) in mCodeList" :key="index">
          <el-popover
            trigger="hover"
            placement="top"
            :content="item.is_used ? $t('code_used') : $t('code_can_be_used')"
            popper-class="assignmentPopper"
            ><div
              class="code-single-style"
              :style="{ color: item.is_used ? '#B5B5BE' : '#000000' }"
              slot="reference"
            >
              {{ item.code }}
            </div></el-popover
          >
        </div>
      </div>
      <p class="code-desc" v-html="tipText"></p>
    </div>
    <div class="flex" style="margin: 32px 0 30px 0">
      <mui-button
        class="code-button"
        @click="onClick"
        type="yellow"
        size="large"
        :loading="loading"
        :loadingText="$t('loading')"
        >{{ buttonText }}</mui-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { getCodesByOrder } from '@/serves/api/useCode'
import { testConfig } from '@/config'
import { toJson } from '@/utils/utils'

export default {
  name: 'CodesShowDialog',
  data() {
    return {
      dialogCurrency: false,
      loading: false,
      buttonText: '',
      titleText: '',
      // 支付成功后的codes文本显示
      mCodesDisplay: '',
      mCodeList: [],
      tipText: '',
      levelData: {
        codes: '',
        level_num: 0,
        level_type: '',
      },
      forceJump: false,
    }
  },
  computed: {},
  methods: {
    /**
     * 显示兑换码展示弹框
     * @param {*} orderId 订单id
     * @param {*} forceJump 是否强制跳转，无论点击关闭还是点击跳转按钮
     */
    openDialog(orderId, forceJump) {
      this.forceJump = forceJump
      console.log('等级配置', this.$store.state.level.levelList)
      // orderId = 'stripe_20231214160205593692437'
      console.log('订单id', orderId)
      this.dialogCurrency = true
      this.loading = true
      if (orderId) {
        getCodesByOrder({ order_id: orderId })
          .then((res) => {
            // this.$message({ type: 'error', message: err })
            this.levelData = res?.data
            console.log('支付成功 根据订单id查询数据', this.levelData)
            this.refreshText()
          })
          .catch((err) => {
            this.$message({ type: 'error', message: err })
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$message({ type: 'error', message: this.$t('pay_fail') })
        this.closeDialog()
      }
    },
    refreshText() {
      // this.mCodeList = this.levelData.codes
      this.mCodeList = toJson(this.levelData.codes)
      console.log('codes列表', this.mCodeList)
      let levelName = this.levelData.level_type + this.levelData.level_num
      if (this.levelData.level_type == 'HSK' && this.levelData.level_num == 7) {
        levelName = 'HSK7-9'
      }
      this.tipText = this.$t('buy_code_tip', {
        level_name: levelName,
      })
      this.buttonText = this.$t('btn_goto_papers', {
        level_name: levelName,
      })
      this.titleText = this.$t('finished_pay_discount_title', {
        level_name: levelName,
      })
    },
    // // 合并购买完成后的codes到一条文本中 并进行显示
    // codesShowPayFinished() {
    //   let str = ''
    //   str += '<span style="color: #fc5a5a;font-size: 16px;font-weight: 500;">' + 1 + '</span>'
    // },
    // codesShowDetail() {},
    closeDialog() {
      this.loading = false
      this.dialogCurrency = false
      if (this.forceJump) {
        this.forceJump = false
        this.onClick()
      }
    },
    onClick() {
      if (this.loading) return
      this.loading = true
      // level_type testConfig 区分hsk hskk yct
      // level_id 等级id hsk 1-6 yct 7 9 10 11
      // level_index 序号 hsk 1-6 yct 1-4
      let typeStr = this.levelData.level_type.toLocaleLowerCase()
      let type =
        typeStr == 'hsk' ? testConfig.HSK : typeStr == 'hskk' ? testConfig.HSKK : testConfig.YCT
      let config = this.$store.state.level.levelList
      let levelIndex = type == testConfig.HSK ? 0 : type == testConfig.HSKK ? 1 : 2
      let levelData = config[levelIndex]?.levels
      let level_id = levelData[this.levelData.level_num - 1].id
      this.$store
        .dispatch('level/changeLevel', {
          levelType: type,
          levelId: level_id,
          levelIndex: this.levelData.level_num,
        })
        .then(() => {
          this.closeDialog()
          this.$router.push({
            path: `/${typeStr || 'hsk'}/tests`,
            query: {
              level: `${typeStr}${this.levelData.level_num}`,
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.code-dialog {
  .code-title {
    color: #2c2f46;
    padding-top: 20px;
    padding-left: 24px;
    margin-bottom: 20px;
    font-family: Proxima Nova;
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0em;
    text-align: center;
  }
  .code-body {
    padding: 0px 25px;
    letter-spacing: 0em;
    text-align: center;
    color: #000000;
    font-family: Proxima Nova;

    .code-desc {
      font-size: 16px;
      font-weight: 400;
      line-height: 19px;
      color: #696974;
    }
    .code-display {
      display: flex;
      flex-direction: row;
      justify-content: center;
      flex-wrap: wrap;
      text-align: left;
    }
    .code-list {
      .code-single-style {
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        background-color: #efeff1;
        font-family: Proxima Nova;
        font-size: 28px;
        font-weight: 700;
        line-height: 44px;
        letter-spacing: 0em;
        // border: 1px solid #000000;
        width: 236px;
        height: 82px;
        border-radius: 6px;
        margin: 15px 14px;
      }
    }
  }
  .code-button {
    width: auto;
    min-width: 254px;
    height: 40px;
    border-radius: 4px;
    margin: 0 auto;
    margin-bottom: 27px;

    font-family: Proxima Nova;
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: center;
  }
}
</style>
